
export const confirm = function (options) {
    options = options || {};
    alertify.defaults.glossary.title = options.title || 'Potwierdź akcję';
    alertify.defaults.glossary.ok = options.ok || 'Tak';
    alertify.defaults.glossary.cancel = options.cancel || 'Nie';
    alertify.defaults.transition = options.transition || 'fade';
    alertify.confirm(options.message, function () {
        if (options.onConfirm && _.isFunction(options.onConfirm)) {
            options.onConfirm();
        }
    }, function () {
        if (options.onCancel && _.isFunction(options.onCancel)) {
            options.onCancel();
        }
    });
};
